import React, { Component } from 'react'

import { post } from '../../api'

import Modal from '../Modal/Modal'
import Form from '../Form/Form'

class AddLBU extends Component {

    state = {
        name: '',
    }

    onSave = async () => {
        try {
            const { name = '' } = this.state
            if (name.trim() === '') {
                return
            }
            const lbu = await post('/lbus', { name })
            this.props.onAdded(lbu)
        } catch (err) {
            alert(err.message)
        }
    }

    render() {
        const { name = '' } = this.state

        return (
          <Modal
            narrow
            extraClassName="AddLBU"
            onCancel={this.props.onClose}
            onSave={this.onSave}
            saveText="Continue"
            mode="edit"
            title="Add LBU">
            <Form>
                <div>
                    <input
                        autoComplete="off"
                        autoCorrect="off"
                        autoCapitalize="off"
                        spellCheck="false"
                        type="text"
                        placeholder="Name"
                        value={name}
                        onChange={e => this.setState({ name: e.target.value })} />
                </div>
            </Form>
          </Modal>
        )
    }
}

export default AddLBU



// WEBPACK FOOTER //
// ./src/components/LBUs/AddLBU.js